// extracted by mini-css-extract-plugin
export default {"card":"SampleCard_card__pwYUw","crd_title":"SampleCard_crd_title__xiTfQ","img_wrapper":"SampleCard_img_wrapper__PoRDh","build_time":"SampleCard_build_time__-C6ov"};